module.exports = __webpack_public_path__ + "img/gas-ok.a20aa438.svg";